import { ref, watch, computed } from "@vue/composition-api";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";

export default function useList() {
  const tableColumns = [
    { key: "actions", sortable: false, label: "Acciones" },
    { key: "name", sortable: true, label: "Nombre" },
    { key: "created_at", sortable: true, label: "date.created_at" },
  ];

  const perPage = ref(10);
  const currentPage = ref(1);
  const totalList = ref(0);
  const searchQuery = ref("");
  const sortBy = ref("created_at");
  const isSortDirDesc = ref(true);
  const perPageOptions = [10, 25, 50, 100];

  const refListTable = ref(null);
  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const toast = useToast();
  const fetchList = () =>
    new Promise((resolve, reject) => {
      const params = {
        page: currentPage.value,
        per_page: perPage.value,
        sort_by: sortBy.value,
        sort_desc: isSortDirDesc.value ? 1 : 0,
        search: searchQuery.value,
      };
      axios
        .get("/v1/bau_complement_templates", { params })
        .then((response) => {
          const { data, meta } = response.data;
          totalList.value = meta.total;
          resolve(data);
        })
        .catch(() => {
          toast.error("Error al obtener la lista de plantillas de Complemento BAU");
          reject();
        });
    });

  watch([perPage, currentPage, searchQuery, sortBy, isSortDirDesc], () => {
    refetchData();
  });

  const refetchData = () => {
    if (refListTable.value) refListTable.value.refresh();
  };

  return {
    fetchList,
    tableColumns,
    perPage,
    currentPage,
    totalList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    refetchData,
  };
}
